export default {
  data () {
    return {
      addedOrderTypeList: [
        { NAME: '原始订单', ID: 0 },
        { NAME: '加单', ID: 1 },
        { NAME: '补单', ID: 2 },
        { NAME: '应急订单', ID: 3 },
        { NAME: '现金采购', ID: 4 },
        { NAME: '退货订单', ID: 5 },
        { NAME: '第4方订单', ID: 10 },
      ],
    }
  },
  computed: {},
  methods: {
    getAddedOrderTypeLabel(addedOrderType){
      const o = this.addedOrderTypeList.find(({ID}) => ID == addedOrderType);
      return o ? o.NAME : '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/mixins/orderMixin.js